import { KeyboardEventModifier, ScreenSpaceEventHandler, ScreenSpaceEventType } from 'cesium';

type CesiumScreenSpaceInputAction =
	| ScreenSpaceEventHandler.MotionEventCallback
	| ScreenSpaceEventHandler.PositionedEventCallback
	| ScreenSpaceEventHandler.WheelEventCallback
	| ScreenSpaceEventHandler.TwoPointEventCallback
	| ScreenSpaceEventHandler.TwoPointMotionEventCallback;

interface InputActions {
	// With keyboard modifier
	MOUSE_MOVE__SHIFT: CesiumScreenSpaceInputAction;
	LEFT_CLICK__SHIFT: CesiumScreenSpaceInputAction;
	RIGHT_CLICK__SHIFT: CesiumScreenSpaceInputAction;
	LEFT_CLICK__CTRL: CesiumScreenSpaceInputAction,

	// Without keyboard modifier
	LEFT_CLICK: CesiumScreenSpaceInputAction;
	RIGHT_CLICK: CesiumScreenSpaceInputAction;
	LEFT_DOWN: CesiumScreenSpaceInputAction;
}

export const OriginalCesiumInputActions: InputActions = {
	// With keyboard modifier
	MOUSE_MOVE__SHIFT: {} as CesiumScreenSpaceInputAction,
	LEFT_CLICK__SHIFT: {} as CesiumScreenSpaceInputAction,
	RIGHT_CLICK__SHIFT: {} as CesiumScreenSpaceInputAction,
	LEFT_CLICK__CTRL: {} as CesiumScreenSpaceInputAction,

	// Without keyboard modifier
	LEFT_CLICK: {} as CesiumScreenSpaceInputAction,
	RIGHT_CLICK: {} as CesiumScreenSpaceInputAction,
	LEFT_DOWN: {} as CesiumScreenSpaceInputAction
};

export const saveOriginalCesiumInputActions = (
	screenSpaceEventHandler: ScreenSpaceEventHandler
) => {
	// With keyboard modifier
	OriginalCesiumInputActions.MOUSE_MOVE__SHIFT = screenSpaceEventHandler.getInputAction(
		ScreenSpaceEventType.MOUSE_MOVE,
		KeyboardEventModifier.SHIFT
	);
	OriginalCesiumInputActions.LEFT_CLICK__SHIFT = screenSpaceEventHandler.getInputAction(
		ScreenSpaceEventType.LEFT_CLICK,
		KeyboardEventModifier.SHIFT
	);
	OriginalCesiumInputActions.RIGHT_CLICK__SHIFT = screenSpaceEventHandler.getInputAction(
		ScreenSpaceEventType.RIGHT_CLICK,
		KeyboardEventModifier.SHIFT
	);

	OriginalCesiumInputActions.LEFT_CLICK__CTRL = screenSpaceEventHandler.getInputAction(
		ScreenSpaceEventType.LEFT_CLICK,
		KeyboardEventModifier.CTRL
	);

	// Without keyboard modifier
	OriginalCesiumInputActions.LEFT_CLICK = screenSpaceEventHandler.getInputAction(
		ScreenSpaceEventType.LEFT_CLICK
	);
	OriginalCesiumInputActions.RIGHT_CLICK = screenSpaceEventHandler.getInputAction(
		ScreenSpaceEventType.RIGHT_CLICK
	);
	OriginalCesiumInputActions.LEFT_DOWN = screenSpaceEventHandler.getInputAction(
		ScreenSpaceEventType.LEFT_DOWN
	);
};
